// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import DownloadOutlinedSvg from "@ant-design/icons-svg/lib/asn/DownloadOutlined";
import AntdIcon from "../components/AntdIcon";
const DownloadOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: DownloadOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    DownloadOutlined.displayName = "DownloadOutlined";
}
export default /*#__PURE__*/ React.forwardRef(DownloadOutlined);
